module.exports = __webpack_public_path__ + "d83f9bdfc10ad79207362d53489bc7ee.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-chuah.png
// module id = 233
// module chunks = 30